import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    motorModelAll: [],
    motorModel: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const insurerVariantSlice = createSlice({
    name: "insurerVariant",
    initialState,
    reducers: {
        setMotorModelAll: (state, action) => {
            state.motorModelAll = action.payload;
        },
        setMotorModel: (state, action) => {
            state.motorModel = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
})

export const { setMotorModelAll, setMotorModel, setCurrentPage, setTotalPages, setRowsPerPage } = insurerVariantSlice.actions;
export default insurerVariantSlice.reducer;